import UtilsUrl from "../../utils/UtilsUrl";
import api from "./../api";






class KpiProductionService{



  getProductionStateByDateBetween(id, debutDate, finDate) {
      return api.get(UtilsUrl.KpiProductionURL() + "/getProductionStateByDateBeeteen/" + id, {
        params: {
          debutDate: debutDate,
          finDate: finDate,
        },
      });
    }

}
export default new KpiProductionService();
